// extracted by mini-css-extract-plugin
export default {"component":"P+z6B"};